// Unsplash responsive sources: phones download a ~640px image instead of 1200px.
export const imgSet = (url) => ({
  src: url,
  srcSet: `${url.replace("w=1200", "w=640")} 640w, ${url} 1200w`,
  sizes: "(max-width: 768px) 100vw, 1200px",
});
